import { useState, useEffect, useRef } from 'react';
import Skeleton from '@mui/material/Skeleton';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { PaginationItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

const InputDataTableCopy = ({ RowComponent, tableHeader, dataList, numToPage, overflowFlag, showSpinner, skeletonHeight, overrideMessage=false,disableMaxTableHeight=false,varHeight='220px'}) =>{
    // initialize state
    const [page, setPage] = useState(1);
    const [pageList, setPageList] = useState([]);
    const [showDataList, setShowDataList] = useState([]);
    const [tableCss, setTableCss] = useState('table');
    const [numOfPages, setNumOfPages] = useState(0);
    // initialize ref
    const count = useRef(0);

    // function to make count equal to 0
    const zeroCount = () =>{
        count.current = 0;
    } 

    // increment count by 1
    const incrementCount = () =>{
        count.current = count.current + 1;
    }

    // event handler when page changes due to pagination component click
    const onPageChange = (event, value) => {
        setPage(page => page = parseInt(value));
    }

    // Function to calculate pagination start and end values
    function calculatePagination(totalItems, itemsPerPage, currentPage) {
        const start = (currentPage - 1) * itemsPerPage + 1;
        let end = currentPage * itemsPerPage;
        if (end > totalItems) {
            end = totalItems;
        }
        return { start, end };
    }

    // useEffect to run on change of dataList state variable
    useEffect(() => {
        setPage(page => page = 1);
        // determine number of pages and the page list that will 
        if(numToPage){
            let temp = parseInt(dataList.length / numToPage);
            if (dataList.length % numToPage > 0){
                temp = temp + 1;
            }
            setNumOfPages(numOfPages => numOfPages = temp);
            let tempList = [];
            for (let i = 0; i < temp; i++){
                tempList.push(i+1);
            }   
            setPageList(pageList => pageList = tempList);
        }
        // if overflow flag is true allow horizontal scroll
        if (overflowFlag){
            setTableCss(tableCss => tableCss = 'table-overflow');
        }
    }, [dataList]);

    // useEffect to update data to display on page of table when dataList or page state variables change
    useEffect(() => {
        if (numToPage){
            let startIndex = (page - 1) * numToPage;
            setShowDataList(showDataList => showDataList = [...dataList.slice(startIndex, startIndex + numToPage)]);
        }
        else{
            setShowDataList(showDataList => showDataList = dataList);
        }
    }, [page, dataList]); 

    return(
        <>
            {!showSpinner ?
                <>
                    <Paper>
                        <TableContainer sx={{  maxHeight: disableMaxTableHeight ?  "none": "calc(100vh - "+varHeight+")", overflow: "overlay"}}>
                            <Table stickyHeader size="small">
                                {/* display headers */}
                                <TableHead>
                                    <TableRow>
                                        {tableHeader.map( el => 
                                            <TableCell
                                            sx={{
                                                // backgroundColor:"#CCDBE3",
                                                backgroundColor: process.env.REACT_APP_PRIMARY_COLOR, 
                                                color:`${process.env.REACT_APP_HEADER_TEXT_COLOR} !important`, 
                                                borderRight: "1px solid white !important",
                                              }}
                                            >
                                                {el['columntag']}
                                            </TableCell>
                                        )} 
                                    </TableRow>
                                </TableHead>
                                {/* display body of table */}
                                <TableBody>
                                    {/* zero count at the start of each row */}
                                    {zeroCount()}
                                    {Object.keys(showDataList).map( (row, index) =>
                                        <TableRow 
                                            key={index}
                                            sx={{
                                                backgroundColor:
                                                index % 2 !== 0 ? "#F7F9FA" : "#FFFFFF",
                                            }}
                                        >
                                            {/* apply row component function to each row object */}
                                            {/* pass table headers to row component so order can be held */}
                                            {RowComponent(showDataList[row], count.current, tableHeader)}  
                                            {/* increment count for each element in row */}
                                            {incrementCount()}                
                                        </TableRow>    
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        { !showSpinner && !overrideMessage && dataList.length == 0 && tableHeader.length > 0 ? 
                            <div className="d-flex flex-column justify-content-end align-items-center p-2">
                                <ErrorOutlineIcon sx={{fontSize:"40px"}}/>
                                <Typography>No Data Available.</Typography>
                            </div>
                            :numToPage && numOfPages > 1 ?
                            <div className="d-flex justify-content-end align-items-center p-2">
                                {/* if specified number of rows to page and there is more than one page show pagination component */}
                                <Typography
                                    fontSize={"12px"}
                                    paddingRight={"8px"}
                                    fontWeight={"400"}
                                    lineHeight={"16px"}
                                >
                                {calculatePagination(dataList.length, numToPage, page).start +
                                    "-" +
                                    calculatePagination(dataList.length, numToPage, page).end +
                                    " of " +
                                    dataList.length +
                                    " items"}
                                </Typography>
                                <Pagination page={page} count={numOfPages} variant="outlined" shape="rounded" onChange={onPageChange}
                                    renderItem={(item) => (
                                        <PaginationItem
                                          {...item}
                                          components={{
                                            previous: () => (
                                              <Typography fontSize={"12px"}>Previous</Typography>
                                            ),
                                            next: () => (
                                              <Typography fontSize={"12px"}>Next</Typography>
                                            ),
                                          }}
                                        />
                                      )}
                                />
                            </div>
                            :<></>}
                    </Paper>
                </>
            :<>
                {/* show skeleton while showSpinner prop is true */}
                {/* generally used for waiting for api response */}
                <br/>
                <Skeleton variant="rectangular" width='100%' height='7vh' sx={{ borderRadius: '10px', 'margin-bottom': '3px'}}/>
                <Skeleton variant="rectangular" width='100%' height={skeletonHeight} sx={{ borderRadius: '10px'}}/>
                <br/>
            </>}
        </>
    );
}

export default InputDataTableCopy;